<template>

  <div>

    <DefaultLayout>
      <!-- Breadcrumb Section Begin -->
      <div class="breacrumb-section">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb-text">
                <router-link to="/"><i class="mdi mdi-home"></i> {{ $t("main.home") }}</router-link>
                <span>{{ $t("auth.login") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Breadcrumb Form Section Begin -->

      <!-- Register Section Begin -->
      <div class="register-login-section spad">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="text-center alert alert-danger" v-if="has_error && !success">
                <p class="">{{ error }}</p>
              </div>
              <div class="loader" v-if="loader"></div>
              <div class="login-form">
                <h2>{{ $t("auth.login") }}</h2>
                <form method="post" @submit.prevent="login" v-if="!success">
                  <div class="group-input" v-bind:class="{ 'has-error': has_error && errors.email }">
                    <label for="username" v-bind:class="{
                      'text-danger': has_error && errors.email,
                    }">{{ $t("attr.email") }} *</label>
                    <input type="text" id="email" v-model="email" />
                    <span class="text-danger help-block" v-if="has_error && errors.email">{{ errors.email[0] }}</span>
                  </div>
                  <div class="group-input" v-bind:class="{ 'has-error': has_error && errors.password }">
                    <label for="password" v-bind:class="{
                      'text-danger': has_error && errors.password,
                    }">{{ $t("attr.password") }} *</label>
                    <input type="password" id="password" v-model="password" v-bind:class="{
                      'is-invalid': has_error && errors.password,
                    }" />
                    <span class="help-block text-danger" v-if="has_error && errors.password">{{ errors.password[0]
                    }}</span>
                  </div>
                  <div class="group-input gi-check">
                    <div class="gi-more">
                      <label for="save-pass">
                        {{ $t("action.save") }} {{ $t("attr.password") }}
                        <input type="checkbox" id="save-pass" />
                        <span class="checkmark"></span>
                      </label>

                      <router-link :to="{ name: 'forgot' }" class="forget-pass">{{
                        $t("auth.forget-password")
                      }}</router-link>
                    </div>
                  </div>
                  <button type="submit" class="btn-site btn-auth">
                    {{ $t("auth.sign-in") }}
                  </button>
                </form>
                <div class="switch-login">
                  <router-link :to="{ name: 'register' }" class="or-login">
                    {{ $t("general.or") }} {{ $t("action.create") }}
                    {{ $t("general.an") }} {{ $t("auth.account") }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </DefaultLayout>
  </div>
</template>

<script>
import DefaultLayout from '@/layouts/DefaultLayout.vue';

export default {
  data() {
    return {
      name: "",
      email: "",
      password: "",
      password_confirmation: "",
      has_error: false,
      error: "",
      errors: {},
      success: false,
      loader: false,
      regEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
    };
  },
  components: {
    DefaultLayout,
  },
  methods: {
    login () {
      var app=this;
      let email=this.email;
      let password=this.password;
      let data={};

      if (!app.regEmail.test(email)) {
        data={
          username: email,
          password,
        };
      } else {
        data={
          email,
          password,
        };
      }

      app.loader=true;
      this.$store
        .dispatch("login", data)
        .then((response) => {
          app.user=response.data.data.user;
          app.notifications=response.data.data.notifications;
          app.messages=response.data.data.messages;
          console.log(response.data.data);
          console.log(response.data.data.messages);
          
          app.loader=false;
          if (Object.keys(app.$route.query).length!==0) {
            app.$router.push(app.$route.query.redirect);
            return;
          }

          app.$router.push({ name: "dashboardBase" });
        })
        .catch(function (err) {
          app.loader=false;
          app.has_error=true;
          // alert(err)
          // Try to extract a readable message
          const res=err.response?.data||{};
          const data=res.data||{};
          const message=res.message||res.error||res.msg;

          // If "data" is an object with validation errors, build a readable string
          if (typeof data==='object'&&Object.keys(data).length>0) {
            app.errors=data;
            app.error=Object.values(data).flat().join('\n');
          } else {
            app.errors={};
            app.error=message||app.$t("auth.error.message", { action: app.$t("auth.login") });
          }
        });

    },
  },
  computed: {
    tokenExpiryDate: {
      get() {
        return this.$store.state.tokenExpiryDate;
      },
      set(expiryDate) {
        this.$store.commit("set_token_expiry_date", { expiryDate: expiryDate });
      },
    },
    user: {
      get() {
        return this.$store.state.user;
      },
      set(user) {
        this.$store.commit("setUser", { user: user });
      },
    },
    notifications: {
      get() {
        return this.$store.state.notifications;
      },
      set(notifications) {
        this.$store.commit("setNotifications", {
          notifications: notifications,
        });
      },
    },
    messages: {
      get() {
        return this.$store.state.messages;
      },
      set(messages) {
        this.$store.commit("setMessages", {
          messages: messages,
        });
      },
    },
  },
};
</script>
